
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/client/api-docs",
      function () {
        return require("private-next-pages/docs/client/api-docs.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/client/api-docs"])
      });
    }
  